import React from "react";

import {
  formatCurrency,
  getTextCutByLength,
  MAX_TEXT_CUT_LENGTH,
} from "@covertree/utils";
import { Box, Grid, Typography } from "@mui/material";

import { CustomAccordion } from "../../accordions";
import { Tooltip } from "../../Tooltip";

export interface PaymentSummaryItem {
  name: string;
  value: number;
}

interface Props {
  sectionName: string;
  items?: PaymentSummaryItem[];
}

export function SummarySection({ sectionName, items }: Props) {
  return (
    <Box
      mt={1}
      sx={(theme) => ({
        "& > div > div:first-of-type": {
          minHeight: theme.spacing(6),
          height: theme.spacing(6),
        },
      })}>
      <CustomAccordion
        header={() => (
          <Box width="100%">
            {" "}
            <Typography variant="h5">{sectionName}</Typography>
          </Box>
        )}
        content={
          <Box mt={1} width="100%">
            {items?.map(({ name, value }) => (
              <Grid
                key={name}
                container
                sx={{ marginTop: "-6px" }}
                justifyContent="space-between"
                spacing={1}>
                <Grid item>
                  <Typography variant="subtitle1">
                    {getTextCutByLength(name)}
                    {name.length > MAX_TEXT_CUT_LENGTH && (
                      <Tooltip
                        tooltip={name}
                        dataTestId={`${name}-wrapped-text-tooltip`}
                      />
                    )}
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography variant="subtitle1">
                    {formatCurrency(value)}
                  </Typography>
                </Grid>
              </Grid>
            ))}
          </Box>
        }
        contentSx={{ paddingX: 0 }}
        arrowToRight
        withoutAccent
        expandOnInit={window.innerHeight > 680}
      />
    </Box>
  );
}
